/**
 * Event status → UIChip colour (Base Chips, `appearance="light"`).
 * `ongoing`/`completed`/`canceled` match the Figma; `upcoming`/`pending` are a
 * best guess pending the design link.
 */
export const STATUS_CHIP_COLOR = {
  ongoing: "success",
  upcoming: "info",
  completed: "warning",
  pending: "secondary",
  canceled: "error",
  cancelled: "error",
};
